import React from 'react'

const withValue = WrappedComponent =>
  class extends React.Component {
    state = {
      value: this.props.value || '',
    }

    componentWillReceiveProps = ({ value }) => {
      if (value !== this.state.value) {
        this.setState({ value })
      }
    }

    onChange = e => this.setState({ value: e.target.value })

    render = () => (
      <WrappedComponent
        onChange={this.onChange}
        select={value =>
          this.props.onChange
            ? this.props.onChange({ target: { value } })
            : this.setState({ value })
        }
        {...this.props}
        value={this.props.onChange ? this.props.value : this.state.value}
      />
    )
  }

export default withValue



// WEBPACK FOOTER //
// ./src/components/withSuggestions/withValue.js